import { render } from "./Nav.vue?vue&type=template&id=3bb0cfa5&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=3bb0cfa5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb0cfa5"]])

export default __exports__